import { render, staticRenderFns } from "./SbsOverview.vue?vue&type=template&id=59673df1&scoped=true"
import script from "./SbsOverview.vue?vue&type=script&lang=js"
export * from "./SbsOverview.vue?vue&type=script&lang=js"
import style0 from "./SbsOverview.vue?vue&type=style&index=0&id=59673df1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59673df1",
  null
  
)

export default component.exports